var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SessionBreadcrumbs',{attrs:{"sessionId":_vm.sessionId,"backRoute":_vm.backRoute,"backLabel":_vm.translate('action.back')}}),_c('Divider'),_c('ViewSessionProgress',{attrs:{"sessionId":_vm.sessionId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }